namespace ui
{
	export namespace Form
	{

		export interface ILabelledNumberSliderDescriptor
			extends INumberInputDescriptor
		{
			min:				number;
			step:				number;
			max:				number;
			sentinal?:	string;
		}

		export class LabelledNumberSlider
			extends BasicInputField<HTMLElement, ILabelledNumberSliderDescriptor>
		{

			/**
			 * Shadowing Default property to only except numbers.
			 */
			public readonly	Default:				number;

			private		m_Text:					JQuery<HTMLSpanElement>;
			private		m_Input:				Slider;
			private		fn_Translater:	(value: number) => string;
			private		m_Sentinal:			string;

			/**
			 *
			 * @param descriptor The LabelledSlider specific descriptor for initialization.
			 * @param display The callback function to translate a given string by the slider range values.
			 * @param value The default value for the slider.
			 */
			public constructor(
				value: number,
				descriptor: ILabelledNumberSliderDescriptor,
				display: (value: number) => string = ( _n: number ): string => _n.toString() )
			{
				super( 'labelled-slider', descriptor, InputValueTypes.NUMBER );

				// Don't delegate classes to input field
				let inputDescriptor: ILabelledNumberSliderDescriptor|{} = {};
				inputDescriptor = Object.assign({}, descriptor);
				delete (inputDescriptor as ILabelledNumberSliderDescriptor).classes;

				this.Default				= value;

				this.m_Text					= ui.$$.label();
				this.m_Input				= new Slider( value, inputDescriptor );

				this.fn_Translater	= display;

				this.m_Input.Initialize();
				this.m_Input.Input().appendTo( this.m_Root );

				this.m_Root.append( this.m_Text );

				this.m_Input
					.on( 'click', () => { this.showTextByValue(); } )
					.on( 'input', () => { this.showTextByValue(); } )
					.on( 'change', () => { this.showTextByValue(); } );

				this.m_Sentinal			= this.Descriptor.sentinal || '';
			}

			public rebuild( root: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement> ): LabelledNumberSlider
			{
				super.rebuild( root );

				this.m_Input.Input().removeClass( 'form-control' );

				this.showTextByValue();

				return this;
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.control )
				{
					this.m_Text.addClass( 'form-control' );
				}

				if ( this.Descriptor.sentinal )
				{
					this.m_Input.attr( 'min', this.Descriptor.min - 1 );
				}

				this.m_Root.removeClass( 'form-control' );
				this.m_Base.removeClass( 'form-control' );

				this.m_Input.value( this.Default );
			}

			public val(): number|null
			{
				const val = this.m_Input.val();

				return this.Descriptor.sentinal && val < this.Descriptor.min ? null : val;
			}

			public value( value: number|null ): LabelledNumberSlider
			{
				this.m_Input.value( value === null ? this.Descriptor.min : value );

				this.showTextByValue();

				return this;
			}

			public reset(): void
			{
				this.value( this.Default );
			}

			private showTextByValue(): void
			{
				const val = this.val();

				if ( val === null )
				{
					this.m_Text.text( this.m_Sentinal );
				}
				else
				{
					this.m_Text.text( this.fn_Translater( val ) );
				}
			}

		}

	}
}
